// Copyright (c) 2016 Deere & Company

import ClaimAction, {getDefaultState as getClaimActionDefaultState} from './claim-action';
import ClaimFailureInfo, {getDefaultState as getClaimFailureInfoDefaultState} from './claim-failure-info';
import ClaimIncentiveCustomer, {getDefaultState as getClaimIncentiveCustomer} from './claim-incentive-customer';
import ClaimIncentiveProgram, {getDefaultState as getClaimIncentiveProgram} from './claim-incentive-program';
import ClaimRecordInfo, {getDefaultState as getClaimClaimRecordInfoDefaultState} from './claim-record-info';
import ClaimReferenceInfo, {getDefaultState as getClaimReferenceInfoDefaultState} from './claim-reference-info';
import ClaimReimbursementDetails, {getDefaultState as getClaimReimbursementDetailsDefaultState} from './claim-reimbursement-details';
import ClaimRgaStatus, {getDefaultState as getClaimRgaStatusDefaultState} from './claim-rga-status';
import ClaimRules, {getDefaultState as getClaimRulesDefaultState} from './claim-rules';
import ClaimValueDetails, {getDefaultState as getClaimValueDetailsDefaultState} from './claim-value-details';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';

import ClaimLabor from './claim-item-labor';
import ClaimOtherCredit from './claim-item-other-credit';
import ClaimPart from './claim-item-part';
import ClaimUseAmount from './claim-use-amount';
import ClaimVsrMessage from './claim-vsr-message';
import File from './file';
import t from 'tcomb';

const ClaimIncentive = t.struct({
    allowedActions: t.list(ClaimAction, 'AllowedActions'),
    allowedPrograms: t.list(ClaimIncentiveProgram, 'AllowedPrograms'),
    claimNumber: t.String,
    claimStatus: KeyValuePair,
    claimType: KeyValuePair,
    claimValueDetails: ClaimValueDetails,
    customer: ClaimIncentiveCustomer,
    errors: t.list(ClaimVsrMessage, 'Errors'),
    failureInfo: ClaimFailureInfo,
    file: t.maybe(t.list(File, 'Files')),
    goodsInstallationVat: t.maybe(KeyValuePair),
    hideClaimValueDetails: t.Bool,
    isDuplicateClaim: t.Bool,
    isEditable: t.Bool,
    labor: t.maybe(t.list(ClaimLabor, 'Labor')),
    otherCredits: t.maybe(t.list(ClaimOtherCredit, 'OtherCredits')),
    parts: t.maybe(t.list(ClaimPart, 'Parts')),
    pin: t.String,
    recordInfo: ClaimRecordInfo,
    referenceInfo: ClaimReferenceInfo,
    reimbursementDetails: ClaimReimbursementDetails,
    responsibleAccount: Dealer,
    rgaStatus: ClaimRgaStatus,
    rules: ClaimRules,
    selectedAction: ClaimAction,
    selectedProgram: ClaimIncentiveProgram,
    showAmountsInLocalCurrency: t.Bool,
    showValidate: t.Bool,
    subClaimType: KeyValuePair,
    useAmounts: t.list(ClaimUseAmount, 'UseAmounts'),
    validationFailed: t.Bool,
    version: t.String
}, {
    name: 'ClaimIncentive',
    strict: true
});

export const getDefaultState = () => new ClaimIncentive({
    allowedActions: [
        new ClaimAction({
            actionName: 'DRAFT',
            id: 'DRAFT',
            mode: 'CHG'
        })
    ],
    allowedPrograms: [],
    claimNumber: '',
    claimStatus: getKeyValuePairDefaultState(),
    claimType: new KeyValuePair({
        key: 'ZZMK',
        value: ''
    }),
    claimValueDetails: getClaimValueDetailsDefaultState(),
    customer: getClaimIncentiveCustomer(),
    errors: [],
    failureInfo: getClaimFailureInfoDefaultState(),
    file: [],
    goodsInstallationVat: getKeyValuePairDefaultState(),
    hideClaimValueDetails: false,
    isDuplicateClaim: false,
    isEditable: true,
    labor: [],
    otherCredits: [],
    parts: [],
    pin: '',
    recordInfo: getClaimClaimRecordInfoDefaultState(),
    referenceInfo: getClaimReferenceInfoDefaultState(),
    reimbursementDetails: getClaimReimbursementDetailsDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    rgaStatus: getClaimRgaStatusDefaultState(),
    rules: getClaimRulesDefaultState(),
    selectedAction: getClaimActionDefaultState(),
    selectedProgram: getClaimIncentiveProgram(),
    showAmountsInLocalCurrency: false,
    showValidate: true,
    subClaimType: new KeyValuePair({
        key: 'PMI',
        value: ''
    }),
    useAmounts: [],
    validationFailed: false,
    version: ''
});

ClaimIncentive.prototype.vsrErrorMessages = function vsrErrorMessages() {

    return this.errors.filter(vsrMessage => vsrMessage.type.key === 'E');

};

ClaimIncentive.prototype.vsrWarningMessages = function vsrWarningMessages() {

    return this.errors.filter(vsrMessage => vsrMessage.type.key === 'W');

};

ClaimIncentive.prototype.vsrInfoMessages = function vsrInfoMessages() {

    return this.errors.filter(vsrMessage => vsrMessage.type.key === 'I');

};

export default ClaimIncentive;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-incentive.js